export default {
  path: '/article',
  meta: {
    title: '资讯详情',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/article`),
}



// WEBPACK FOOTER //
// ./src/views/Article/router.js